import React from 'react'
import { runOnNextTick } from 'util/functions'
import { getLength } from 'util/arrays'

import AddNewIntegration from './AddNewIntegration'
import EmailMarketing from './EmailMarketing'
import GitHubInAppCard from './GitHubInAppCard'
import JiraCloudInAppCard from './JiraCloudInAppCard'
import JiraServerInAppCard from './JiraServerInAppCard'
import Shopify from './Shopify'
import Stripe from './Stripe'
import TrelloInAppCard from './TrelloInAppCard'
import HubspotCard from './Hubspot'
import SalesforceCard from './Salesforce'

const INTEGRATION_COMPONENTS = {
  atlassian_oauth2: JiraCloudInAppCard,
  github: GitHubInAppCard,
  jira_server: JiraServerInAppCard,
  shopify: Shopify,
  stripe_connect: Stripe,
  trello: TrelloInAppCard,
  hubspot: HubspotCard,
  salesforce: SalesforceCard,
}
class Integrations extends React.Component {
  componentDidMount() {
    const { loadEmailMarketingIntegrations } = this.props
    if (process.env.NODE_ENV === 'test') return
    runOnNextTick(loadEmailMarketingIntegrations)
  }

  render() {
    const { integrations, customerId } = this.props

    return (
      <React.Fragment>
        <div>
          {integrations.map(integration => {
            const { provider, id, type } = integration
            const integrationProps = {
              provider,
              id,
              key: id,
              customerId,
              integration,
            }
            const legacyProps = {
              ...integrationProps,
              key: `legacy_${id}`,
              type,
            }
            if (
              ['MAILCHIMP', 'CONSTANT_CONTACT', 'CAMPAIGN_MONITOR'].includes(
                type
              )
            ) {
              return <EmailMarketing {...legacyProps} />
            }
            const IntegrationComponent = INTEGRATION_COMPONENTS[provider]
            if (IntegrationComponent) {
              return <IntegrationComponent {...integrationProps} />
            }
            return null
          })}
        </div>
        <AddNewIntegration needsSeparator={getLength(integrations) === 0} />
      </React.Fragment>
    )
  }
}

export default Integrations
